
/**
 *
 * @class TextMeasure
 *
 * helper for measuring the bounding area of text on the canvas
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export class TextMeasure {

  /** the canvas we use to make a drawing context on */
  public static sandbox: HTMLCanvasElement|null        = null;

  /** the drawing context we can use for measuring */
  public static context: CanvasRenderingContext2D|null = null;

  /**
   *
   * @param text the text to measure
   * @param font the font styling to assume while measuring
   *
   */
  public static measure(text: string, font: string): {width: number, height: number} {

    /* make sure we have a working canvas and drawing context */

    if (!TextMeasure.sandbox) {

      TextMeasure.sandbox = document.createElement('canvas');

      TextMeasure.context = TextMeasure.sandbox.getContext('2d');
    }

    if (!TextMeasure.context) {

      return {width: 0, height: 0};
    }

    /* make sure we have a drawing context */

    TextMeasure.context.font          = font;
    TextMeasure.context.textBaseline  = 'middle';

    let width: number  = TextMeasure.context.measureText(text).width;
    let height: number = 10;

    let matches: RegExpMatchArray|null = font.match(/\s+(\d+)px\s+/);

    if (matches) {

      height = parseInt(matches[1]);
    }

    return {width, height};
  }
}
